G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.InfectedStatus = function(candy) {
  this.wrapperImg = null;

  G.BoardCandy.CandyStatus.call(this, {});
};

G.BoardCandy.InfectedStatus.prototype = Object.create(G.BoardCandy.CandyStatus.prototype);

G.BoardCandy.InfectedStatus.prototype.init = function(candy, config) {
  G.BoardCandy.CandyStatus.prototype.init.call(this, candy, config);
  this.wrapperImg = G.makeImage(0, 0, "infection_front", 0.5, candy);
  game.add.tween(this.wrapperImg)
    .from({alpha: 0, width: 0, height:0},250,Phaser.Easing.Sinusoidal.Out,true);

  G.sb("onCandyInfect").dispatch(this.candy);
};

G.BoardCandy.InfectedStatus.prototype.onMatch = function() {
  this.signals.onRemove.dispatch();
  this.remove();
  return false;
};

G.BoardCandy.InfectedStatus.prototype.remove = function() {
  G.sb("fxTop").dispatch('burstInfectionAnim', this.candy, this.candy);

  G.stopTweens(this.wrapperImg);
  game.add.tween(this.wrapperImg)
    .to({alpha: 0},250,Phaser.Easing.Sinusoidal.Out,true)
    .onComplete.add(function() {
      this.wrapperImg.destroy();
    },this)
  G.sb("onCandyInfectionRemove").dispatch(this.candy);
};